export enum Priority {
  Low = 1,
  Middle = 5,
  High = 10,
}

export enum PriorityText {
  Low = 'low',
  Middle = 'middle',
  High = 'high',
}
